// extracted by mini-css-extract-plugin
module.exports = {"text":"ProductSlider_text__3681j"};